import request from '@/utils/request'
import { contactsList } from './contacts_score_config.js'

// 提交idfa 和通讯录
function addressBook () {
  const contant = getContactsFromStorage()
  const idfa = localStorage.getItem('idfa') || ''
  if (contant || idfa) {
    const contantList = JSON.stringify(contant) || JSON.stringify([])
    request.post('addressBook', { contantList, idfa: idfa.replace(/"/g, '') })
  }
}

// 接收app传递的通讯录和idfa参数
window.setContant = function (list) {
  localStorage.setItem('contact', JSON.stringify(list))
}
window.setIdfa = (idfa) => {
  localStorage.setItem('idfa', idfa)
}

// 兼容多种通讯录储存到localStorage的key
export function getContactsFromStorage () {
  let contant = ''
  // 使用some方法，当找到有值的key时会自动终止循环
  contactsList.some(key => {
    console.log(key.contactKey)
    const valueJSON = localStorage.getItem(key.contactKey)
    if (valueJSON) {
      const valueArray = JSON.parse(valueJSON)
      contant = valueArray.map(item => ({
        accountName: item[key.name],
        accountPhone: item[key.phone]
      }))
      return true
    }
    return false
  })
  return contant
}
export default addressBook
